import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchEmployeeLeaves = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.EMPLOYEE_LEAVE.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter
      // total_count:totalItems
    }
  });
}

export const fetchEmployeeLeaveLedgerSummary = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.EMPLOYEE_LEAVE.LEAVE_LEDGER_SUMMARY_LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter
      // total_count:totalItems
    }
  });
}

export const fetchEmployeeLeavesHistory = (page_no, filter, employee_code_id, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.EMPLOYEE_LEAVE.LEAVE_HISTORY_LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      employee_code_id,
      ...filter
      // total_count:totalItems
    }
  });
}

export const fetchEmployeeLeaveHistory = (payload) => {
  return axiosInstance.get(EndPoints.EMPLOYEE_LEAVE.LEAVE_HISTORY_BY_ID_LIST + `/${payload}`);
}

export const fetchEmployeeLeave = (payload) => {
  return axiosInstance.get(EndPoints.EMPLOYEE_LEAVE.LIST_BY_ID + `/${payload}`);
}

export const createEmployeeLeave = (payload) => {
  return axiosInstance.post(EndPoints.EMPLOYEE_LEAVE.CREATE, payload)
}

export const updateEmployeeLeave = (payload) => {
  return axiosInstance.put(EndPoints.EMPLOYEE_LEAVE.UPDATE, payload)
}

export const approveEmployeeLeave = (payload) => {
  return axiosInstance.put(EndPoints.EMPLOYEE_LEAVE.APPROVE_UPDATE, payload)
}

export const receiveEmployeeLeave = (payload) => {
  const url = `${EndPoints.EMPLOYEE_LEAVE.RECEIVE_UPDATE}/?po_id=${payload.po_id}&received_by=${payload.received_by}`;
  return axiosInstance.put(url);
};

export const deleteEmployeeLeave = (payload) => {
  const url = EndPoints.EMPLOYEE_LEAVE.DELETE + `/${payload}`
  return axiosInstance.delete(url)
}

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.EMPLOYEE_LEAVE.DOWNLOAD_CSV, {
    responseType: 'blob'
  });
}

export const fetchLeaveMaster = (page_no = 1, filter = {}, limit = DEFAULT_TOTAL_RECORDS) =>
  axiosInstance.get(EndPoints.LEAVE_MASTER.LIST, {
    params: { limit, page_no, ...filter },
  });

export const fetchLeaveMasterDropdown = () =>
  axiosInstance.get(EndPoints.LEAVE_MASTER.DROPDOWN);

export const createLeaveMaster = (payload) =>
  axiosInstance.post(EndPoints.LEAVE_MASTER.CREATE, payload);

export const updateLeaveMaster = (payload) =>
  axiosInstance.put(EndPoints.LEAVE_MASTER.UPDATE, payload);

export const deleteLeaveMaster = (id) =>
  axiosInstance.delete(`${EndPoints.LEAVE_MASTER.DELETE}/${id}`);

export const creditLeaveMaster = (payload) =>
  axiosInstance.post(EndPoints.LEAVE_MASTER.CREDIT, payload);
